import { CustomerService, IApplicationFilter, PortfolioReportCache, property, widget } from '@dynamik/common';
import { BindingEngine, computedFrom } from 'aurelia-framework';
import { WidgetBase } from '@dynamik/common';
import { addMonths, format, parseISO } from '../../../date-fns-local';
import { customElement } from 'aurelia-templating';
import { CustomerTotalValuesReportViewModel } from '@dynamik/common/clients/reporting-clients';

@customElement('nav-key-figures-widget')
@widget('NAV key figures', true, true, 'Description')
export class NavKeyFiguresWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, private portfolioReportCache: PortfolioReportCache, bindingEngine: BindingEngine) {
    super(element, bindingEngine, customerService);
  }

  navYTD: number;
  navYTDLM?: number;
  osebxYTD: number;
  osebxYTDLM?: number;
  navLM: number;
  osebxLM?: number;
  noGL: boolean;

  @property('Data', 'NAV')
  showNav: boolean = true;

  @property('Data', 'OSEBX')
  showOsebx: boolean = true;

  @property('Data', 'Last month')
  showLastMonth: boolean = true;

  @property('Data', 'YTD')
  showYTD: boolean = true;

  @property('Data', 'YDT LM')
  showYTDLastMonth: boolean = true;

  @property('Table')
  font?: string;

  @property('Table')
  fontSize?: number = 25;

  @property('Table')
  color?: string;

  @property()
  captionFont?: string;

  @property()
  captionFontSize?: number = 12;

  @property()
  captionColor?: string;

  @computedFrom('config.showOsebx', 'config.showNav', 'config.showLastMonth', 'config.showYTD', 'config.showYTDLastMonth')
  get showLabels() {
    return (this.showOsebx && this.showNav)
      || (this.showLastMonth ? 1 : 0) + (this.showYTD ? 1 : 0) + (this.showYTDLastMonth ? 1 : 0) > 1;
  }

  override async loadData(filter: IApplicationFilter) {
    return this.portfolioReportCache.customerTotals(filter.customer.companyId, undefined, filter.dates.toStr, undefined, false);
  }

  override async setData(data: CustomerTotalValuesReportViewModel[]) {
    const ytd = data[data.length - 1];
    this.noGL = !ytd?.netAssetValueClosingBalance;
    this.navYTD = ytd?.netAssetValueChangeYearToDateInPercent ?? 0 * 100;
    this.osebxYTD = ytd?.indexSellpriceChangeYearToDateInPercent ?? 0 * 100;
    const date = parseISO(this.customerService.selectedDates.toStr);
    if (date.getMonth() > 0) {
      const ytdlm = data.find(x => x.dateClosingBalance === format(addMonths(date, -1), 'yyyy-MM-dd\'T\'00:00:00\'Z\''));
      this.navYTDLM = ytdlm?.netAssetValueChangeYearToDateInPercent ?? 0 * 100;
      this.osebxYTDLM = ytdlm?.indexSellpriceChangeYearToDateInPercent ?? 0 * 100;
      this.navLM = this.navYTD - this.navYTDLM;
      this.osebxLM = this.osebxYTD - this.osebxYTDLM;
    }
    this.excelData = {
      fileName: 'NAV Key Figures',
      data: { Items: data }
    };
  }
}
